export const overviewSectionConfig = [
    {
        category: 'Sanitation',
        title: 'SDG Indicators for Sanitation',
        order: 1,
        fields: [
            { name: 'safelymanaged', label: 'Safely managed', unit : '%' },
            { name: 'basic', label: 'Basic', unit : '%' },
            { name: 'limited', label: 'Limited', unit : '%' },
            { name: 'unimproved', label: 'Unimproved', unit : '%' },
            { name: 'opendefecation', label: 'Open defecation', unit : '%' }
        ]
    },
    {
        category: 'General',
        title: 'General Information',
        order: 2,
        fields: [
            { name: 'area', label: 'Area', unit:'Km²' },
            { name: 'population', label: 'Population', unit:'K' },
            { name: 'density', label: 'Density', unit:'/Km²' },
            { name: 'wards', label: 'Wards' }
        ]
    },
    {
        category: 'SanitationProfile',
        title: 'Sanitation Profile',
        order: 3,
        fields: [
            { name: 'fsgeneration', label: 'FS Generation', unit : 'm³/day'  },
            { name: 'fscollection', label: 'FS Collection', unit : '%'  },
            { name: 'fstreatment', label: 'FS Treatment', unit : '%'  },
            { name: 'fstp', label: 'FSTP' }
        ]
    },
    {
        category: 'SWM',
        title: 'SWM Summary',
        order: 4,
        fields: [
            { name: 'swgeneration', label: 'SW Generation', unit : 'ton/day'  },
            { name: 'swcollection', label: 'SW Collection', unit : '%'  },
            { name: 'swtreatment', label: 'SW Treatment', unit : '%'  },
            { name: 'swtp', label: 'SWTP' }
        ]
    }
];

export const indicatorsSectionConfig = [
    {
        title: "CWIS",
        category: "CWIS",
        order: 1,
        fields: [
            {
                name: "percentageofpopulationwithaccesstoimprovedindividualtoilets",
                label: "Percentage of population with access to improved individual toilets",
                unit : '%',
                icon: "fa-solid fa-door-open"
            },
            {
                name: "willingnesstopayfortoiletimprovementinpercentage",
                label: "Willingness to pay for toilet improvement in Percentage",
                unit : '%',
                icon: "fa-solid fa-hands-holding"
            },
            {
                name: "willingnesstopayforcontainmentimprovementinpercentage",
                label: "Willingness to pay for containment improvement in Percentage",
                unit : '%',
                icon: "fa-solid fa-hand-holding-dollar"
            },
            {
                name: "percentageofaccessiblecontainments",
                label: "Percentage of accessible containments",
                unit : '%',
                icon: "fa-solid fa-box-open"
            },
            {
                name: "percentageofdesludgingservicescompletedmechanicallyorsemimechanically",
                label: "Percentage of desludging services completed mechanically or semi-mechanically",
                unit : '%',
                icon: "fa-solid fa-gears"
            },
            {
                name: "percentageofcollectedfsdisposedattreatmentplantordesignateddisposalsites",
                label: "Percentage of collected FS disposed at treatment plant or designated disposal sites",
                unit : '%',
                icon: "fa-solid fa-recycle"
            },
            {
                name: "percentageofwatercontaminationcompliance",
                label: "Percentage of water contamination compliance",
                unit : '%',
                icon: "fa-solid fa-droplet"
            }
        ]
    },
    {
        title: "Solid Waste Management (SWM)",
        category: "Solid Waste Management (SWM)",
        order: 2,
        fields: [
            {
                name: "percentageofwastesegregationatsource",
                label: "Percentage of waste segregation at source",
                unit : '%',
                icon: "fa-solid fa-trash"
            },
            {
                name: "percentageofwastecollectsbyvanoperatedbyulb",
                label: "Percentage of waste collected by van operated by ULB",
                unit : '%',
                icon: "fa-solid fa-dolly"
            },
            {
                name: "percentageofwastecollectsbyvanoperatedbyotheragencies",
                label: "Percentage of waste collected by van operated by other agencies",
                unit : '%',
                icon: "fa-solid fa-truck"
            }
        ]
    }
];
export const infrastructureSectionConfig = [
    {
        category: 'Tools used by Conservancy Department',
        title: 'Tools used by Conservancy Department',
        order: 1,
        fields: [
            { name: 'dustbin', label: 'Dustbin' },
            { name: 'vacuumtanker', label: 'Vacuum Tanker' },
            { name: 'sts', label: 'STS' }
        ]
    },
    {
        category: 'Vehicles used in SWM',
        title: 'Vehicles used in SWM',
        order: 2,
        fields: [
            { name: 'compactor', label: 'Compactor' },
            { name: 'dumptruck', label: 'Dump Truck' },
            { name: 'others', label: 'Others (Vehicles)' },
            { name: 'trolley', label: 'Trolley' }
        ]
    }
];
export const InstitutionalCapacitySectionConfig = [
    {
        category: 'Human Resources',
        title: 'Human Resources',
        order: 1,
        fields: [
            { name: 'conservancyofficials', label: 'Conservancy Officials' },
            { name: 'wastecollectors', label: 'Waste Collectors' },
            { name: 'pitcleaners', label: 'Pit Cleaners' },
            { name: 'roadcollectors', label: 'Road Collectors' },
            { name: 'privatepitcleaners', label: 'Private Pit Cleaners' }
        ]
    }
];